import React from 'react';
import { Alert } from 'reactstrap';
import styles from './index.module.scss';
import { AlertProps } from './types';

const { warningAlert } = styles;

export const AlertWarning = (props: AlertProps) => <Alert data-testid={props.testId} color='warning' className={warningAlert}>{props.children}</Alert>;
